import React from 'react';
import Resource from '../../../common/Resource'
import Panel from '../../../common/layout/Panel'

export default class extends React.Component {
    render () {
        const data = {
            url: '/admin/carriers/settings/rewrite',
            data: {
                data: [],
                metadata: []
            },
            metadata:
                [
                    {
                        'label': 'id',
                        'source': 'ATROUTREWRITEGROUPID',
                        'type': 'primary',
                        'editable': false,
                        'visible': false
                    },
                    {
                        'label': 'Rewrite Group Name',
                        'source': 'ATRNAME',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'New rewrite group...'
                    },
                    {
                        'label': 'Enabled',
                        'source': 'ATRSTATUS',
                        'type': 'checkbox',
                        'editable': true,
                        'visible': true,
                        'default' : true
                    },
                    {
                        label: 'View',  
                        value: '/carriers/settings/rewrite/{$id}',
                        type: 'link'
                    },
                    {
                        'label' : 'Actions',
                        'type': 'action_buttons'
                    }
                ]
        }
        return (
            <Panel title = "Carrier Outgoing Rewrite Groups">
                <Resource data = {data} {...this.props} addButtonValue="Add Outgoing Rewrite Group" />
            </Panel>
        )
    }
}
